// components/common/ProtectedRoute.tsx - GÜNCELLENMİŞ
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string | string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { user, loading, isAuthenticated, hasPermission } = useAuth();

  // Debug logging
  console.log('🛡️ ProtectedRoute check:', {
    loading,
    isAuthenticated,
    user: user ? { id: user.id, name: user.name, role: user.role } : null,
    requiredRole,
    hasPermission: requiredRole ? hasPermission(requiredRole) : 'N/A'
  });

  // Loading durumu
  if (loading) {
    console.log('⏳ ProtectedRoute: Loading...');
    return <LoadingSpinner />;
  }

  // Giriş yapılmamışsa login sayfasına yönlendir
  if (!isAuthenticated || !user) {
    console.log('🔐 ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Eğer requiredRole belirtilmemişse, tüm authenticated kullanıcılara izin ver
  if (!requiredRole) {
    console.log('✅ ProtectedRoute: No role required, access granted');
    return <>{children}</>;
  }

  // Rol kontrolü - hasPermission metodunu kullan
  const hasRequiredRole = hasPermission(requiredRole);

  console.log('🔐 Role check result:', {
    hasRequiredRole,
    userRole: user.role,
    requiredRole,
    userDetails: user
  });

  if (!hasRequiredRole) {
    console.log('🚫 ProtectedRoute: Access denied - insufficient permissions');
    return <Navigate to="/unauthorized" replace />;
  }

  console.log('✅ ProtectedRoute: Access granted');
  return <>{children}</>;
};

export default ProtectedRoute;